import { createStructuredSelector } from "reselect";

import { ApiModel } from "constants/loading";

import {
  getConsignableSalesIsFetching,
  getIsFetchingAgencies,
  getIsFetchingAuctionPens,
  getIsFetchingBidders,
  getIsFetchingBillingDocuments,
  getIsFetchingBillingRuns,
  getIsFetchingBillingSettings,
  getIsFetchingBusinesses,
  getIsFetchingBusinessLabels,
  getIsFetchingBusinessUserRoles,
  getIsFetchingCandidateDeclarations,
  getIsFetchingComments,
  getIsFetchingConsignments,
  getIsFetchingDeployments,
  getIsFetchingDraftingInformation,
  getIsFetchingEContractAgreements,
  getIsFetchingEContractSpecialConditions,
  getIsFetchingEContracts,
  getIsFetchingEmail,
  getIsFetchingENVDDocuments,
  getIsFetchingExportP2PInFiles,
  getIsFetchingExportP2PInReversals,
  getIsFetchingExportP2POutFiles,
  getIsFetchingExportP2POutReversals,
  getIsFetchingFiles,
  getIsFetchingIntegrationBusinesses,
  getIsFetchingIntegrationCredentials,
  getIsFetchingLedgerAccounts,
  getIsFetchingLedgerEntries,
  getIsFetchingLivestockAgentRoles,
  getIsFetchingLivestockAgents,
  getIsFetchingLoads,
  getIsFetchingManualAdjustments,
  getIsFetchingMasterLedgerAccounts,
  getIsFetchingMasterRuleBooks,
  getIsFetchingMasterRules,
  getIsFetchingMasterRuleSets,
  getIsFetchingNominations,
  getIsFetchingNVDUploads,
  getIsFetchingPayments,
  getIsFetchingPenArchetypes,
  getIsFetchingPermissionGroups,
  getIsFetchingProperties,
  getIsFetchingReceivalLots,
  getIsFetchingReportJobs,
  getIsFetchingReports,
  getIsFetchingRounds,
  getIsFetchingRuleBooks,
  getIsFetchingRules,
  getIsFetchingRuleSets,
  getIsFetchingSaleDefinitions,
  getIsFetchingSaleLots,
  getIsFetchingSales,
  getIsFetchingSaleStatuses,
  getIsFetchingSaleVendorSplits,
  getIsFetchingSaleWatcherRoles,
  getIsFetchingSaleyardAdminRoles,
  getIsFetchingSaleyardAdmins,
  getIsFetchingSaleyards,
  getIsFetchingScaleOperatorRoles,
  getIsFetchingScans,
  getIsFetchingSellFiles,
  getIsFetchingSellReversals,
  getIsFetchingSellViaExAgentRebates,
  getIsFetchingSightingFiles,
  getIsFetchingSingleWeighs,
  getIsFetchingSpecies,
  getIsFetchingTakeFiles,
  getIsFetchingTakeReversals,
  getIsFetchingTradingTerms,
  getIsFetchingTransporterRoles,
} from "./root";
import { getIsFetchingScanLabels } from "./root.state";

export const isLoadingSaleReports = state =>
  getIsFetchingBusinesses(state) ||
  getIsFetchingSaleLots(state) ||
  getIsFetchingConsignments(state) ||
  getIsFetchingReports(state);

// If we're fetching any of these, we can't reliably say what state our nlis files are in.
export const getIsFetchingNLISInformation = state =>
  getIsFetchingTakeFiles(state) ||
  getIsFetchingTakeReversals(state) ||
  getIsFetchingSellFiles(state) ||
  getIsFetchingSellReversals(state) ||
  getIsFetchingConsignments(state) ||
  getIsFetchingSaleLots(state) ||
  getIsFetchingSightingFiles(state);

export const getIsFetchingRoles = state =>
  getIsFetchingSaleyardAdminRoles(state) ||
  getIsFetchingLivestockAgentRoles(state) ||
  getIsFetchingSaleWatcherRoles(state) ||
  getIsFetchingScaleOperatorRoles(state) ||
  getIsFetchingBusinessUserRoles(state) ||
  false;

export const selectItemsFetching = createStructuredSelector({
  [ApiModel.AGENCIES]: getIsFetchingAgencies,
  [ApiModel.AUCTION_PENS]: getIsFetchingAuctionPens,
  [ApiModel.BIDDERS]: getIsFetchingBidders,
  [ApiModel.BILLING_DOCUMENTS]: getIsFetchingBillingDocuments,
  [ApiModel.BILLING_RUNS]: getIsFetchingBillingRuns,
  [ApiModel.BILLING_SETTINGS]: getIsFetchingBillingSettings,
  [ApiModel.BUSINESS_USER_ROLES]: getIsFetchingBusinessUserRoles,
  [ApiModel.BUSINESS_LABELS]: getIsFetchingBusinessLabels,
  [ApiModel.BUSINESSES]: getIsFetchingBusinesses,
  [ApiModel.CANDIDATE_DECLARATIONS]: getIsFetchingCandidateDeclarations,
  [ApiModel.COMMENTS]: getIsFetchingComments,
  [ApiModel.CONSIGNABLE_SALES]: getConsignableSalesIsFetching,
  [ApiModel.CONSIGNMENTS]: getIsFetchingConsignments,
  [ApiModel.DEPLOYMENTS]: getIsFetchingDeployments,
  [ApiModel.DRAFTING_INFORMATION]: getIsFetchingDraftingInformation,
  [ApiModel.ECONTRACT_AGREEMENTS]: getIsFetchingEContractAgreements,
  [ApiModel.ECONTRACT_SPECIAL_CONDITIONS]:
    getIsFetchingEContractSpecialConditions,
  [ApiModel.ECONTRACTS]: getIsFetchingEContracts,
  [ApiModel.EMAIL]: getIsFetchingEmail,
  [ApiModel.ENVD_DOCUMENTS]: getIsFetchingENVDDocuments,
  [ApiModel.NLIS_EXPORT_P2P_IN_FILES]: getIsFetchingExportP2PInFiles,
  [ApiModel.NLIS_EXPORT_P2P_IN_REVERSALS]: getIsFetchingExportP2PInReversals,
  [ApiModel.NLIS_EXPORT_P2P_OUT_FILES]: getIsFetchingExportP2POutFiles,
  [ApiModel.NLIS_EXPORT_P2P_OUT_REVERSALS]: getIsFetchingExportP2POutReversals,
  [ApiModel.FILES]: getIsFetchingFiles,
  [ApiModel.INTEGRATION_BUSINESSES]: getIsFetchingIntegrationBusinesses,
  [ApiModel.INTEGRATION_CREDENTIALS]: getIsFetchingIntegrationCredentials,
  [ApiModel.LEDGER_ACCOUNTS]: getIsFetchingLedgerAccounts,
  [ApiModel.LEDGER_ENTRIES]: getIsFetchingLedgerEntries,
  [ApiModel.LIVESTOCK_AGENT_ROLES]: getIsFetchingLivestockAgentRoles,
  [ApiModel.LIVESTOCK_AGENTS]: getIsFetchingLivestockAgents,
  [ApiModel.LOADS]: getIsFetchingLoads,
  [ApiModel.MANUAL_ADJUSTMENTS]: getIsFetchingManualAdjustments,
  [ApiModel.MASTER_LEDGER_ACCOUNTS]: getIsFetchingMasterLedgerAccounts,
  [ApiModel.MASTER_RULE_BOOKS]: getIsFetchingMasterRuleBooks,
  [ApiModel.MASTER_RULE_SETS]: getIsFetchingMasterRuleSets,
  [ApiModel.MASTER_RULES]: getIsFetchingMasterRules,
  [ApiModel.NLIS_SELL_FILES]: getIsFetchingSellFiles,
  [ApiModel.NLIS_SELL_REVERSALS]: getIsFetchingSellReversals,
  [ApiModel.NLIS_TAKE_FILES]: getIsFetchingTakeFiles,
  [ApiModel.NLIS_TAKE_REVERSALS]: getIsFetchingTakeReversals,
  [ApiModel.NOMINATIONS]: getIsFetchingNominations,
  [ApiModel.NVD_UPLOADS]: getIsFetchingNVDUploads,
  [ApiModel.PAYMENTS]: getIsFetchingPayments,
  [ApiModel.PEN_ARCHETYPES]: getIsFetchingPenArchetypes,
  [ApiModel.PERMISSION_GROUPS]: getIsFetchingPermissionGroups,
  [ApiModel.PROPERTIES]: getIsFetchingProperties,
  [ApiModel.RECEIVAL_LOTS]: getIsFetchingReceivalLots,
  [ApiModel.REPORTS]: getIsFetchingReports,
  [ApiModel.REPORT_JOBS]: getIsFetchingReportJobs,
  [ApiModel.ROLES]: getIsFetchingRoles,
  [ApiModel.ROUNDS]: getIsFetchingRounds,
  [ApiModel.RULE_BOOKS]: getIsFetchingRuleBooks,
  [ApiModel.RULE_SETS]: getIsFetchingRuleSets,
  [ApiModel.RULES]: getIsFetchingRules,
  [ApiModel.SALE_DEFINITIONS]: getIsFetchingSaleDefinitions,
  [ApiModel.REFRESH_SCAN_LABELS]: getIsFetchingScanLabels,
  [ApiModel.SALE_LOTS]: getIsFetchingSaleLots,
  [ApiModel.SALE_STATUSES]: getIsFetchingSaleStatuses,
  [ApiModel.SALE_VENDOR_SPLITS]: getIsFetchingSaleVendorSplits,
  [ApiModel.SALE_WATCHER_ROLES]: getIsFetchingSaleWatcherRoles,
  [ApiModel.SALES]: getIsFetchingSales,
  [ApiModel.SALEYARD_ADMIN_ROLES]: getIsFetchingSaleyardAdminRoles,
  [ApiModel.SALEYARD_ADMINS]: getIsFetchingSaleyardAdmins,
  [ApiModel.SALEYARDS]: getIsFetchingSaleyards,
  [ApiModel.SCALE_OPERATOR_ROLES]: getIsFetchingScaleOperatorRoles,
  [ApiModel.SCANS]: getIsFetchingScans,
  [ApiModel.SINGLE_WEIGH]: getIsFetchingSingleWeighs,
  [ApiModel.SPECIES]: getIsFetchingSpecies,
  [ApiModel.TRANSPORTER_ROLES]: getIsFetchingTransporterRoles,
  [ApiModel.TRADING_TERMS]: getIsFetchingTradingTerms,
  [ApiModel.SELL_VIA_EX_AGENT_REBATES]: getIsFetchingSellViaExAgentRebates,
});

export const getItemsFetching = requiredData => state => {
  const itemsLoading = selectItemsFetching(state);
  if (requiredData) {
    // Build a lookup of loading status for easier debugging (if required)
    const loadingStatus = Array.isArray(requiredData)
      ? requiredData.reduce((acc, k) => {
          acc[k] = itemsLoading[k];
          return acc;
        }, {})
      : itemsLoading[requiredData];
    return Object.values(loadingStatus).includes(true);
  } else {
    // Alllll the data.
    return Object.values(itemsLoading).includes(true);
  }
};
